module.exports = __webpack_public_path__ + "img/sh.357bc3cb.png";